import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Avatar, Row, Col, Pagination, message } from "antd";
import * as actions from "../../../store/actions/index";
import { useHistory } from "react-router-dom";
import Tabs from "../../../components/Tab/Tab";
import _ from "lodash";
import axiosRequest from "../../../axios-request/request.methods";
import "./ApplicationAll.css";
import NoRecordsFound from "../../NoRcordsFound/NoRecordsFound";
import { stoageSetter } from "../../../helpers";
import Loader from "../../Loader/Loader";
import { renderMandateStatus } from "./SubsequentPaymentUtility";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { routeAsPerProposalStatus } from "../../../config/router.config";
import TriggerSubsequentPayment from "./TriggerSubsequentPayment";
import { tabMenuApplication } from "./ApplicationAll";
import { AthenaProductsRouteHandler } from "../../../config/product.config";

const RejectedApplication = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [fetchApplicationList, setfetchApplicationList] = useState([]);
  const [currentPageNumber, setcurrentPageNumber] = useState(1);
  const [proposalNumberSearch, setProposerNumberSearch] = useState("");
  const [totalLeads, settotalLeads] = useState(0);
  const leadsData = useSelector((state) => state.leads);


  const [isshowMore, setisshowMore] = useState([]); //show more index values
  const [loader, setLoader] = useState(false);
  const [showSubPaymentModal, setShowSubPaymentModal] = useState(false);
  const [triggerSubPaymentData, setTriggerSubPaymentData] = useState(null);

  const dispatch = useDispatch();
  const history = useHistory();

  const id = useSelector((state) => state.login?.user.id);

  const breakpoint = 620;
  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [width]);

  const WebHeightProduct = { height: width > breakpoint ? "30px" : "" };

  useEffect(() => {
    getItemsToDisplay(currentPageNumber, proposalNumberSearch);
  }, []);

  const getItemsToDisplay = async (Nextpage, policyId) => {
    setLoader(true);

    let res = null;
    res = policyId
      ? await axiosRequest.get(`user/getAgentproposal/${id}?proposalStatus=Rejected&skip=${(Nextpage - 1) * 15}&sort_status=&sorByFlter=Proposalstarted&searchType=policyId&searchtxt=${policyId}`)
      : await axiosRequest.get(`user/getAgentproposal/${id}?proposalStatus=Rejected&skip=${(Nextpage - 1) * 15}&sort_status=&sorByFlter=Proposalstarted`);
    console.log("page new result-->", res);

    if (res?.errCode === 529) {
      setfetchApplicationList([]);
      settotalLeads(0);
      setLoader(false);
    } else if (res.length > 0) {
      setLoader(false);
      setfetchApplicationList(res[0]);
      settotalLeads(res[1][0].count);
    } else {
      setLoader(false);
      return <NoRecordsFound />;
    }
  };

  const getRandomColor = () => {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const nameShorter = (str) => {
    let str1 = "UU";
    if (str != "" && str != undefined) {
      str1 = str?.toUpperCase();
      let arr = str1?.split(" ");
      let fLatter = arr[0]?.charAt(0);
      let sLatter = arr[1]?.charAt(0);
      str1 = (fLatter || "UU") + (sLatter || "");
    }

    return str1;
  };

  const ViewHeadline = (e) => {
    let ProposalLocalID = {
      proposalID: e?._id,
    };
    stoageSetter("propsalid", ProposalLocalID);
    history.push("/finalSubmit");
  };

  const routeHandler = async (item) => {
    var id = "";
    var productCode = "";

    productCode = item?.productId?.product_code;

    id = item._id;
    let ProposalLocalID = {
      proposalID: id,
    };
    stoageSetter("propsalid", ProposalLocalID);

    let tracker_res = await axiosRequest.get(`user/getProposal/${id}`);

    if (tracker_res?.errCode !== 256) {
      dispatch(actions.fetchAllProposalSuccess(tracker_res[0]));
      dispatch(actions.fetchBi(tracker_res[0]?.benefitIllustration));
      dispatch(actions.fetchEinsurance(tracker_res[0]?.elinsuranceAccountDetails));
      dispatch(actions.fetchFinancialDetails(tracker_res[0]?.FinancialDetails));
      dispatch(actions.fetchAboutCustomer(tracker_res[0]?.AboutCustomer));
      dispatch(actions.fetchHealthDetails(tracker_res[0]?.HealthDetailsSection));
      dispatch(actions.fetchPreviousPolicyDetails(tracker_res[0]?.PreviousPolicyDetails));
      dispatch(actions.fetchNominationDetails(tracker_res[0]?.NominationDetails));
      dispatch(actions.fetchProposalDetails(tracker_res[0]?.ProposerDetails));
      dispatch(actions.fetchPayments(tracker_res[0]?.paymentOptions));
      dispatch(actions.AddENACHDetails(tracker_res[0]?.eNachStatus));

      dispatch(actions.fetchDelaration(tracker_res[0]?.Declaration));

      const isTeamView = leadsData?.globalTab === "team" ? true : false

      const routingURL = routeAsPerProposalStatus(item, isTeamView);

      if (routingURL === "currentLocationURL") {
        if (item?.currentLocationURL === null || item?.currentLocationURL === undefined || item?.currentLocationURL === "") {
          AthenaProductsRouteHandler(history, productCode);
        } else {
          history.push(item?.currentLocationURL);
        }
      } else {
        history.push(routingURL);
      }
    }
  };

  const handlePageClick = async (page) => {
    setcurrentPageNumber(page);
    await getItemsToDisplay(page, proposalNumberSearch);
    await setisshowMore([]);
  };

  const handleProposalFilter = (policyId) => {
    setProposerNumberSearch(policyId);

    if (policyId === "" || policyId === null || policyId === undefined) {
      getItemsToDisplay(currentPageNumber, policyId);
    } else {
      setcurrentPageNumber(1);
      getItemsToDisplay(1, policyId);
    }
  };

  const showMoreFunc = (index) => {
    let new_val = [...isshowMore];
    new_val.push(index);
    setisshowMore(new_val);
  };
  const showLessFunc = (index) => {
    let new_val = [...isshowMore];
    _.remove(new_val, (new_val_item) => new_val_item == index);
    setisshowMore(new_val);
  };

  const content = (
    <div style={{ borderRadius: "10px" }}>
      <p style={{ cursor: "pointer" }}>Enach Status</p>
      <p style={{ cursor: "pointer" }}>Payment Status</p>
      <p style={{ cursor: "pointer" }}>Docs Status</p>
    </div>
  );

  const showJourneyTerminateReason = (reason) => {
    if (reason.includes("Kindly explore other products.")) {
      let newReason = reason.split("Kindly explore other products.");
      let reasonToDisplay = newReason[0];
      message.warn(reasonToDisplay);
    } else {
      message.warn(reason);
    }
  };

  const handleTriggerSubsequentPayment = async (item) => {
    const result = await axiosRequest.get(`user/checkMandateRetry?proposalId=${item?.policyId}`);

    if (result?.retry === true) {
      setTriggerSubPaymentData(item);
      setShowSubPaymentModal(true);
    }
  };

  const pageLoadAfterSubsequent = () => {
    getItemsToDisplay(currentPageNumber, proposalNumberSearch);
  };

  return (
    <>
      <Tabs header="Applications" tabMenu={tabMenuApplication} activeKey="RejectedApplication" proposalFilter={handleProposalFilter} />

      <>
        <Loader formloader={loader} />
      </>

      <Row justify={"center"}>
        {!fetchApplicationList ? (
          <Loader formloader={loader} />
        ) : (
          fetchApplicationList?.map((item, index) => (
            <Col sm={18} md={18} lg={11} xl={11} index={index} key={index} style={{ width: "100%" }}>
              <div className="LeadCard-Main-Page-Container">
                <Card className="lead-card-desktop" hoverable={false}>
                  <div className="main-avtar">
                    <div className="avatar-and-status">
                      <Avatar
                        style={{
                          paddingTop: "-40px",
                          lineHeight: "none",
                          backgroundColor: getRandomColor(),
                        }}
                        size={{ xl: 50 }}
                      >
                        {nameShorter(item.benefitIllustration.NameofLifeAssured)}
                      </Avatar>
                    </div>
                  </div>

                  <div className="mainContent">
                    <div className="content">
                      <div className="content-header1">
                        <div className="avtar-data">
                          <div className="otp-data">
                            <p className="user-name-text capitalize">{item?.benefitIllustration?.NameofLifeAssured}</p>
                          </div>
                        </div>
                      </div>
                      <hr
                        style={{
                          width: "95%",
                          margin: "3px -30px 4px 0px",
                          opacity: "0.5",
                          color: "lightgray",
                        }}
                      />
                      {width < 620 ? (
                        <>
                          <Row gutter={16}>
                            <Col xs={21} sm={21} md={21} lg={24} xl={24}>
                              <label style={{ fontSize: 12 }}>
                                <b>Product Name</b>
                              </label>
                              <div>{item?.productId?.productName}</div>
                            </Col>
                          </Row>

                          <Row gutter={16}>
                            <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                              <label style={{ fontSize: 12 }}>
                                <b>Proposal Number</b>
                              </label>
                              <div>{item?.policyId}</div>
                            </Col>
                            <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                              <label style={{ fontSize: 12 }}>
                                <b>Draft Date</b>
                              </label>
                              <div>{item?.lastupdatedOn}</div>
                            </Col>
                          </Row>

                          {width < 620 && !isshowMore.includes(index) ? null : (
                            <>
                              <Row gutter={16}>
                                <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                  <label style={{ fontSize: 12 }}>
                                    <b>Premium Frequency</b>
                                  </label>
                                  <div>{item?.benefitIllustration?.PremiumMode}</div>
                                </Col>
                                <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                  <label style={{ fontSize: 12 }}>
                                    <b>Policy Term</b>
                                  </label>
                                  <div>{item.benefitIllustration?.PolicyTerm ? `${item.benefitIllustration?.PolicyTerm} year(s)` : "- years"}</div>
                                </Col>
                              </Row>

                              <Row gutter={16}>
                                <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                  <label style={{ fontSize: 12 }}>
                                    <b>Premium Amount</b>
                                  </label>
                                  <div>{item?.benefitIllustration?.annualisedPremium}</div>
                                </Col>
                                <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                  <label style={{ fontSize: 12 }}>Payment Status</label>
                                  <div>
                                    <label style={{ color: item?.paymentOptions?.paymentStatus === "SUCCESS" ? "green" : item?.paymentOptions?.paymentStatus === "PENDING" ? "gold" : "black" }}>{item?.paymentOptions?.paymentStatus}</label>
                                  </div>
                                </Col>
                              </Row>

                              <Row gutter={16}>
                                <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                  <label style={{ fontSize: 12 }}>
                                    <b>Mandate Status</b>
                                  </label>
                                  <div>{renderMandateStatus(item)}</div>
                                </Col>
                              </Row>

                              <Row gutter={16}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                  <label style={{ fontSize: 12 }}>
                                    <b>Proposal Status</b>
                                  </label>
                                  <div>{item?.proposalStatus}</div>
                                </Col>
                              </Row>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="content-body Datainfo-Main-Container">
                          <div className="Dateinfo-Container-imp">
                            <Card.Grid hoverable={false} className="grid-style">
                              <p className="text-type">Proposal Number</p>
                              <p className="text-content">{item?.policyId}</p>
                            </Card.Grid>
                            <Card.Grid hoverable={false} className="grid-style">
                              <p className="text-type">Product Name</p>
                              <p className="text-content-v2" style={WebHeightProduct}>
                                {item?.productId?.productName}
                              </p>
                            </Card.Grid>
                            <Card.Grid hoverable={false} className="grid-style">
                              <p className="text-type">Mandate Status</p>
                              <p className="text-content">{renderMandateStatus(item)}</p>
                            </Card.Grid>
                            <Card.Grid hoverable={false} className="grid-style">
                              <p className="text-type">Premium Frequency</p>
                              <p className="text-content">{item?.benefitIllustration?.PremiumMode}</p>
                            </Card.Grid>

                            <Card.Grid hoverable={false} className="grid-style AllocatedBy-Heading">
                              <p className="text-type">Policy Term</p>
                              <p className="text-content">{item.benefitIllustration?.PolicyTerm ? item.benefitIllustration?.PolicyTerm : "- years"}</p>
                            </Card.Grid>
                            <Card.Grid hoverable={false} className="grid-style Appoinment-Heading">
                              <p className="text-type">Draft Date</p>

                              <p className="text-content">{item?.lastupdatedOn}</p>
                            </Card.Grid>
                            <Card.Grid hoverable={false} className="grid-style">
                              <p className="text-type">Premium Amount</p>
                              <p className="text-content">{item?.benefitIllustration?.annualisedPremium}</p>
                            </Card.Grid>

                            <Card.Grid hoverable={false} className="grid-style">
                              <p className="text-type">Payment Status</p>
                              <p className="text-content" style={{ fontWeight: "bold", color: item?.paymentOptions?.paymentStatus === "SUCCESS" ? "#06c106" : item?.paymentOptions?.paymentStatus === "PENDING" ? "#ffd900" : "" }}>
                                {item?.paymentOptions?.paymentStatus}
                              </p>
                            </Card.Grid>
                            <Card.Grid hoverable={false} className="grid-style">
                              <p className="text-type">Proposal Status</p>
                              <p className="text-content-v2">{item?.proposalStatus}</p>
                            </Card.Grid>
                          </div>
                        </div>
                      )}
                    </div>

                    <div>
                      {width < 620 ? (
                        <div className="card_footer_btns">
                          <div>
                            {!isshowMore.includes(index) ? (
                              <label
                                role="button"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    // Checks if Enter is pressed
                                    showMoreFunc(index);
                                  }
                                }}
                                className="showMoreLabel"
                                onClick={() => showMoreFunc(index)}
                                style={{ marginTop: 15 }}
                              >
                                Show More <DownOutlined />
                              </label>
                            ) : (
                              <label
                                className="showMoreLabel"
                                role="button"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    // Checks if Enter is pressed
                                    showLessFunc(index);
                                  }
                                }}
                                onClick={() => showLessFunc(index)}
                                style={{ marginTop: 15 }}
                              >
                                Show Less <UpOutlined />
                              </label>
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="card_below_btns_others">
                          <Row align="right"></Row>
                        </div>
                      )}
                    </div>
                  </div>
                </Card>
              </div>
            </Col>
          ))
        )}
      </Row>

      {!fetchApplicationList.length ? (
        <>
          <br />
          <NoRecordsFound />
        </>
      ) : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Row gutter={16}>
            <Col sm={24} md={23} lg={23} xl={24}>
              <Pagination responsive current={currentPageNumber} onChange={handlePageClick} total={totalLeads} defaultPageSize={15} showSizeChanger={false} />
            </Col>
          </Row>
        </div>
      )}

      {showSubPaymentModal === true ? <TriggerSubsequentPayment isModalOpen={showSubPaymentModal} setIsModalOpen={setShowSubPaymentModal} proposalData={triggerSubPaymentData} pageLoadAfterSubsequent={pageLoadAfterSubsequent} /> : null}
    </>
  );
};

export default RejectedApplication;
